(function ($) {
    'use strict';

    $(function () {
        var $chrome = $('#pp-top-chrome');
        var $header = $('#pp-header');
        var $styleDsar = $('#stylePersoDsar');
        var styleDsarHtml = $styleDsar.length ? $styleDsar.html() : '';
        var fontSiteChange = 0;
        var fontScope = '#conteudo-principal, .pp-footer';
        var elementosTextos = ['a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'label', 'div', 'p', 'ins', 'button', 'input', 'textarea', 'li', 'td', 'th', 'small', 'strong'];

        function chromeHeight() {
            return $chrome.outerHeight() || 112;
        }

        function goToContent() {
            var el = document.getElementById('conteudo-principal');
            if (!el) {
                return;
            }
            $('html, body').animate({ scrollTop: $(el).offset().top - chromeHeight() - 16 }, 400);
            el.focus();
        }

        window.goToContent = goToContent;

        function applyLogoContrast(useContrast) {
            var $logo = $('#pp-header-logo');
            if (!$logo.length) {
                return;
            }
            var srcPadrao = $logo.attr('src-padrao');
            var srcContraste = $logo.attr('src-contraste');
            if (useContrast && srcContraste) {
                $logo.attr('src', srcContraste);
                $logo.addClass('pp-header__logo-img--contraste');
            } else if (srcPadrao) {
                $logo.attr('src', srcPadrao);
                $logo.removeClass('pp-header__logo-img--contraste');
            }
        }

        function applyAccessibilityColor(option) {
            if (option === 2) {
                $('body').addClass('contraste-ativo');
                $styleDsar.empty();
                applyLogoContrast(true);
            } else {
                $('body').removeClass('contraste-ativo');
                $styleDsar.html(styleDsarHtml);
                applyLogoContrast(false);
            }
            localStorage.setItem('AccessibilityColor', String(option));
        }

        var cachedColor = parseInt(localStorage.getItem('AccessibilityColor'), 10);
        if (cachedColor === 2) {
            applyAccessibilityColor(2);
        }

        function preventBtn(e) {
            e.preventDefault();
        }

        $('#highContrast').on('click', function (e) {
            preventBtn(e);
            applyAccessibilityColor(2);
        });

        $('#defaultColor').on('click', function (e) {
            preventBtn(e);
            applyAccessibilityColor(1);
        });

        function eachFontElement(fn) {
            elementosTextos.forEach(function (tag) {
                $(fontScope).find(tag).each(fn);
            });
        }

        function changeFont(delta) {
            fontSiteChange += delta;
            eachFontElement(function () {
                var fonte = window.getComputedStyle(this).getPropertyValue('font-size');
                var tamanhoAtual = parseFloat(fonte);
                if (!isNaN(tamanhoAtual)) {
                    this.style.fontSize = (tamanhoAtual + delta) + 'px';
                }
            });
        }

        $('#increaseFont').on('click', function (e) {
            preventBtn(e);
            changeFont(1);
        });

        $('#decreaseFont').on('click', function (e) {
            preventBtn(e);
            changeFont(-1);
        });

        $('#normalFont').on('click', function (e) {
            preventBtn(e);
            eachFontElement(function () {
                this.style.fontSize = '';
            });
            fontSiteChange = 0;
        });

        $('#btMenuAcess').on('click', function () {
            var $collapse = $('#navbarMenuAcessCollapse');
            $collapse.toggleClass('show');
            var open = $collapse.hasClass('show');
            $(this).attr('aria-expanded', open ? 'true' : 'false');
        });

        function initShortcuts() {
            if (typeof shortcut === 'undefined') {
                return;
            }
            shortcut.add('ALT+1', goToContent);
            shortcut.add('ALT+2', function () { applyAccessibilityColor(2); });
            shortcut.add('ALT+4', function () { applyAccessibilityColor(1); });
            shortcut.add('ALT+6', function () { $('#increaseFont').trigger('click'); });
            shortcut.add('ALT+7', function () { $('#decreaseFont').trigger('click'); });
            shortcut.add('ALT+8', function () { $('#normalFont').trigger('click'); });
        }

        if (typeof shortcut !== 'undefined') {
            initShortcuts();
        } else {
            $(window).on('load', initShortcuts);
        }

        /* Select cards */
        function refreshSelectCardVisual($group) {
            $group.find('.pp-select-card').each(function () {
                var checked = $(this).find('.pp-select-card-input').is(':checked');
                $(this).toggleClass('pp-select-card--selected', checked);
            });
        }

        function syncSelectCardGroup($group) {
            var multiplo = String($group.attr('data-dp-select-card-multiplo')) === '1';
            if (!multiplo) {
                refreshSelectCardVisual($group);
                return;
            }
            var $hidden = $group.find('[data-dp-select-card-hidden]');
            var valores = [];
            $group.find('.pp-select-card-input:checked').each(function () {
                valores.push($(this).val());
            });
            $hidden.val(JSON.stringify(valores));
            refreshSelectCardVisual($group);
        }

        $(document).on('change click', '.pp-select-card-input', function () {
            syncSelectCardGroup($(this).closest('.pp-select-card-group'));
        });

        $('.pp-select-card-group').each(function () {
            syncSelectCardGroup($(this));
        });

        /* Smooth scroll */
        $('a[href^="#"]').on('click', function (e) {
            var href = this.getAttribute('href');
            if (!href || href.length < 2) return;
            var $target = $(href);
            if ($target.length) {
                e.preventDefault();
                $('html, body').animate({ scrollTop: $target.offset().top - chromeHeight() - 16 }, 550);
                $('#pp-nav').removeClass('is-open');
                $('#pp-nav-toggle').attr('aria-expanded', 'false');
            }
        });

        /* Header scroll shadow */
        function onScroll() {
            var scrolled = window.scrollY > 10;
            $chrome.toggleClass('is-scrolled', scrolled);
            $header.toggleClass('is-scrolled', scrolled);
        }
        $(window).on('scroll', onScroll);
        onScroll();

        /* Mobile nav */
        $('#pp-nav-toggle').on('click', function () {
            var open = $('#pp-nav').toggleClass('is-open').hasClass('is-open');
            $(this).attr('aria-expanded', open ? 'true' : 'false');
            $(this).find('i').toggleClass('fa-bars', !open).toggleClass('fa-times', open);
        });

        /* Active nav on scroll (home) */
        var sections = ['sobre-privacidade', 'seus-direitos', 'como-solicitar'];
        function updateActiveNav() {
            var scrollPos = window.scrollY + chromeHeight() + 40;
            var current = '';
            sections.forEach(function (id) {
                var el = document.getElementById(id);
                if (el && el.offsetTop <= scrollPos) current = id;
            });
            $('#pp-nav a[data-section]').removeClass('is-active');
            if (current) {
                $('#pp-nav a[data-section="' + current + '"]').addClass('is-active');
            }
        }
        $(window).on('scroll', updateActiveNav);
        updateActiveNav();

        /* Copy protocol (página de sucesso) */
        $('#btn-copiar-protocolo').on('click', function () {
            var $btn = $(this);
            var codigo = $btn.data('codigo') || $('#codigo-protocolo').text();
            if (!codigo) return;
            if (navigator.clipboard) {
                navigator.clipboard.writeText(codigo).then(function () {
                    var htmlOriginal = $btn.html();
                    $btn.html('<i class="fas fa-check"></i> Copiado!');
                    setTimeout(function () {
                        $btn.html(htmlOriginal);
                    }, 2000);
                });
            }
        });

        /* Scroll to track result after consult */
        if ($('#pp-track-result').length) {
            setTimeout(function () {
                var $result = $('#pp-track-result');
                $('html, body').animate({
                    scrollTop: $result.offset().top - chromeHeight() - 16
                }, 450);
            }, 250);
        }

        /* File zone feedback */
        $(document).on('change', '.pp-file-zone input[type="file"]', function () {
            var $zone = $(this).closest('.pp-file-zone');
            var name = this.files && this.files[0] ? this.files[0].name : '';
            if (name) {
                $zone.find('.pp-file-zone__text').html('<strong>' + name + '</strong><br><small>Arquivo selecionado</small>');
                $zone.css({ borderColor: 'var(--pp-accent)', background: 'var(--pp-accent-soft)' });
            }
        });

        /* Scroll to top of form on validation errors */
        if ($('.pp-alert--danger').length && $('#dsar-form-solicitacao').length) {
            setTimeout(function () {
                $('html, body').animate({ scrollTop: $('#dsar-form-solicitacao').offset().top - chromeHeight() - 24 }, 400);
            }, 200);
        }

        $(document).on('click', '[data-pp-accordion-trigger]', function () {
            var $btn = $(this);
            var panelId = $btn.attr('aria-controls');
            var $panel = $('#' + panelId);
            if (!$panel.length) {
                return;
            }
            var isOpen = $btn.attr('aria-expanded') === 'true';
            $btn.attr('aria-expanded', isOpen ? 'false' : 'true');
            $panel.toggleClass('is-open', !isOpen);
            if (isOpen) {
                $panel.attr('hidden', true);
            } else {
                $panel.removeAttr('hidden');
            }
        });

        function initRightsCarousel($root) {
            var $carousel = $root && $root.length ? $root : $('[data-pp-rights-carousel]').first();
            if (!$carousel.length) {
                return;
            }

            var $track = $carousel.find('[data-pp-rights-track]');
            var $slides = $track.children('.pp-rights-carousel__slide');
            var $prev = $carousel.find('[data-pp-rights-prev]');
            var $next = $carousel.find('[data-pp-rights-next]');
            var index = 0;

            function visibleCount() {
                return window.matchMedia('(max-width: 991px)').matches ? 1 : 3;
            }

            function maxIndex() {
                return Math.max(0, $slides.length - visibleCount());
            }

            function gapPx() {
                var styles = window.getComputedStyle($track[0]);
                return parseFloat(styles.columnGap || styles.gap || '0') || 0;
            }

            function update() {
                if (index > maxIndex()) {
                    index = maxIndex();
                }

                var slideWidth = $slides.first().outerWidth() || 0;
                var offset = index * (slideWidth + gapPx());
                $track.css('transform', 'translateX(-' + offset + 'px)');
                $prev.prop('disabled', index <= 0);
                $next.prop('disabled', index >= maxIndex());
            }

            $prev.off('click.ppRightsCarousel').on('click.ppRightsCarousel', function () {
                index = Math.max(0, index - 1);
                update();
            });

            $next.off('click.ppRightsCarousel').on('click.ppRightsCarousel', function () {
                index = Math.min(maxIndex(), index + 1);
                update();
            });

            $(window).off('resize.ppRightsCarousel').on('resize.ppRightsCarousel', function () {
                update();
            });

            update();
        }

        initRightsCarousel();

        /* Feedback visual ao enviar formulários (loading + anti duplo clique) */
        function ativarLoadingBotao($btn, texto) {
            if (!$btn || !$btn.length || $btn.hasClass('is-loading')) {
                return;
            }

            var label = texto || $btn.attr('data-pp-loading-text') || 'Processando...';
            $btn.data('pp-original-html', $btn.html());
            $btn.prop('disabled', true)
                .addClass('is-loading')
                .attr('aria-busy', 'true')
                .html('<i class="fas fa-spinner fa-spin" aria-hidden="true"></i><span>' + label + '</span>');
        }

        $(document).on('submit', '#conteudo-principal form, .pp-header__logout-form', function (e) {
            var $form = $(this);

            if ($form.attr('data-pp-no-loading') === 'true') {
                return;
            }

            if ($form.data('pp-submitting')) {
                e.preventDefault();
                return false;
            }

            var nativeEvent = e.originalEvent;
            var submitter = nativeEvent && nativeEvent.submitter;
            var $btn = submitter
                ? $(submitter)
                : $form.find('button[type="submit"], input[type="submit"]').first();

            if (!$btn.length || $btn.prop('disabled')) {
                return;
            }

            $form.data('pp-submitting', true);
            $form.addClass('is-submitting');
            $form.attr('aria-busy', 'true');

            var loadingText = $btn.attr('data-pp-loading-text')
                || $form.attr('data-pp-loading-text')
                || 'Processando...';

            ativarLoadingBotao($btn, loadingText);
            $form.find('button[type="submit"], input[type="submit"]').not($btn).prop('disabled', true);
        });
    });
})(jQuery);
